const STORAGE_KEY = "organizationNames";

const SUPER_USER_ROLES = ["SUPER_USER", "TECHNICAL_USER"];

const storedUser = () => {
    try {
        return JSON.parse(localStorage.getItem("user") || "null");
    } catch (error) {
        return null;
    }
};

export const readOrganizationNamesCache = (user = storedUser()) => {
    if (!user?.mail || !SUPER_USER_ROLES.includes(user.userRole)) return null;
    try {
        const cached = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
        if (cached?.mail !== user.mail || !Array.isArray(cached?.names?.organizations)) return null;
        return cached.names;
    } catch (error) {
        return null;
    }
};

export const clearOrganizationNamesCache = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
        return;
    }
};

export const writeOrganizationNamesCache = (mail, names) => {
    if (!mail || !Array.isArray(names?.organizations)) return;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ mail, names }));
    } catch (error) {
        clearOrganizationNamesCache();
    }
};
